import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CookieConfigModal from "./CookieConfigModal";
import "../styles/CookieBanner.css";

const COOKIE_CONSENT_KEY = "alfasolCookieConsent";

export default function CookieBanner() {
  const { t } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    setShowBanner(!consent);
  }, []);

  const saveConsent = (consent) => {
    localStorage.setItem(
      COOKIE_CONSENT_KEY,
      JSON.stringify({
        necessary: true,
        analytics: consent.analytics,
        personalization: consent.personalization,
        savedAt: new Date().toISOString(),
      })
    );

    setShowBanner(false);
    setShowModal(false);
  };

  const acceptAll = () => {
    saveConsent({
      analytics: true,
      personalization: true,
    });
  };

  const rejectAll = () => {
    saveConsent({
      analytics: false,
      personalization: false,
    });
  };

  const openConfig = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  if (!showBanner && !showModal) return null;

  return (
    <>
      {showBanner && (
        <div className="cookie-banner" role="dialog" aria-live="polite">
          <p>
            {t("cookies.bannerText")}{" "}
            <a href="/cookies-policy">{t("cookies.bannerLink")}</a>
          </p>

          <div className="cookie-buttons">
            <button className="accept" onClick={acceptAll}>
              {t("cookies.acceptButton")}
            </button>

            <button className="reject" onClick={rejectAll}>
              {t("cookies.rejectButton")}
            </button>

            <button className="configure" onClick={openConfig}>
              {t("cookies.configureButton")}
            </button>
          </div>
        </div>
      )}

      {showModal && (
        <CookieConfigModal
          onSave={saveConsent}
          onClose={closeModal}
        />
      )}
    </>
  );
}